var backButton = '<div class="slick-prev slick-arrow"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="19.6" transform="matrix(-1 0 0 1 40 0)" fill="white" stroke="#576C63" stroke-width="0.8"/><path d="M18.9983 20L23.6652 15.3331L22.332 14L16.332 20L22.332 26L23.6652 24.6669L18.9983 20Z" fill="#576C63"/></svg></div>';
var nextButton = '<div class="slick-next slick-arrow"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="19.6" transform="matrix(-1 0 0 1 40 0)" fill="white" stroke="#576C63" stroke-width="0.8"></circle><path d="M21.0017 20L16.3348 15.3331L17.668 14L23.668 20L17.668 26L16.3348 24.6669L21.0017 20Z" fill="white"/></svg></div>';
////////////annocement-bar///////////////////
$(document).ready(function () {
  function initSlick() {
    if ($(window).width() <= 1200) {
      if (!$('.left-side-content').hasClass('slick-initialized')) {
        $('.left-side-content').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
           autoplay: true,
          infinite: true,
          autoplaySpeed: 4000,
         speed: 600,
        });
      }
    } else {
      if ($('.left-side-content').hasClass('slick-initialized')) {
        $('.left-side-content').slick('unslick');
      }
    }
  }

  // Initialize on page load
  initSlick();

  // Reinitialize on window resize
  $(window).on('resize', function () {
    initSlick();
  });

  
});
/////////testimonial slider////////////
$(document).ready(function(){
  $('.testimonials-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false, 
    infinite: false,
    dots: false
  });
  $('.custom-next').click(function(){
    $('.testimonials-slider').slick('slickNext'); 
  });

  $('.custom-prev').click(function(){
    $('.testimonials-slider').slick('slickPrev'); 
  });

    $('.collection-list-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    rows:0,
    arrows: true, 
    infinite: false,
    dots: false,
    prevArrow: backButton,
    nextArrow: nextButton,
    appendArrows: $('.cstm-slider-btn'),
     responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: true,
              dots: false
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
              dots: false
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              dots: false
            }
          }
        ]
  });
// //////////////collection-slider///////////////////////////////////
      $('.collection-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    rows:0,
    arrows: true, 
    infinite: false,
    dots: false,
    prevArrow: backButton,
    nextArrow: nextButton,
     responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: true,
              dots: false
            }
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              autoplay: true,
              arrows: false,
              dots: false
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              autoplay: true,
              arrows: false,
              dots: false
            }
          }
        ]
  });
});

/////////////collection slider////////////////////
$(window).on('load resize', function () {
  $('.pro-slides').each(function () {
    if ($(window).width() < 769) {
      if (!$(this).hasClass('slick-initialized')) {
        $(this).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
        });
      }
    } else {
      if ($(this).hasClass('slick-initialized')) {
        $(this).slick('unslick');
      }
    }
  });
});

// ///////////code for collection list tabs///////////////////////////////////////
  document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".tab-link");
    const contents = document.querySelectorAll(".tab-content");

    tabs.forEach((tab) => {
      tab.addEventListener("click", function () {
        tabs.forEach(t => t.classList.remove("active"));
        contents.forEach(c => c.classList.remove("active"));

        this.classList.add("active");
        document.getElementById(this.dataset.tab).classList.add("active");
      });
    });
  });
  // $(document).ready(function(){
  //   function initSlick() {
  //     if ($(window).width() < 1440) {
  //       if (!$('.tabs').hasClass('slick-initialized')) { 
  //         $('.tabs').slick({
  //           slidesToShow: 5,
  //           slidesToScroll: 5,
  //           arrows: false,
  //           dots: false,
  //           infinite: false,
  //           variableWidth: true,
  //           swipeToSlide: true
  //         });
  //       }
  //     } else {
  //       if ($('.tabs').hasClass('slick-initialized')) {
  //         $('.tabs').slick('unslick'); // 1440px se upar slick remove
  //       }
  //     }
  //   }

  //   initSlick();
  //   $(window).resize(function(){
  //     initSlick(); // Resize hone par bhi check karega
  //   });
  // });

$(document).on("click", ".readmore", function(e) {
    e.preventDefault();
    var parent = $(this).closest('.item');
    parent.find('.product-description-full').show();
    parent.find('.product-description-short').hide();
});

$(document).on("click", ".readless", function(e) {
    e.preventDefault();
    var parent = $(this).closest('.item');
    parent.find('.product-description-full').hide();
    parent.find('.product-description-short').show();
});
$(document).on("click", ".cstm-readmore", function(e) {
    e.preventDefault();
    var parent = $(this).closest('.cstm-grid-teeth-content-box');
    parent.find('.product-description-full').show();
    parent.find('.product-description-short').hide();
});

$(document).on("click", ".cstm-readless", function(e) {
    e.preventDefault();
    var parent = $(this).closest('.cstm-grid-teeth-content-box');
    parent.find('.product-description-full').hide();
    parent.find('.product-description-short').show();
});
document.addEventListener("DOMContentLoaded", function () {
  const tags = document.querySelectorAll(".tags.link_blog");
  const allButton = document.querySelector(".all.link_blog");
  const blogPosts = document.querySelectorAll(".article"); 
  function filterBlogs(selectedTag) {
    blogPosts.forEach((post) => {
      let postTags = post.getAttribute("data-tags") || ""; 
      
      if (selectedTag === "All") {
        post.style.display = "block"; // All button click -> 
      } else if (postTags.split(", ").includes(selectedTag)) {
        post.style.display = "block"; 
      } else {
        post.style.display = "none"; 
      }
    });
  }
  allButton.classList.add("active"); 
  filterBlogs("All"); 
  allButton.addEventListener("click", function () {
    tags.forEach((tag) => tag.classList.remove("active"));
    this.classList.add("active");
    filterBlogs("All");
  });
  tags.forEach((tag) => {
    tag.addEventListener("click", function () {
      tags.forEach((t) => t.classList.remove("active"));
      allButton.classList.remove("active"); 
      this.classList.add("active");

      let selectedTag = this.getAttribute("data-handle").trim();
      filterBlogs(selectedTag);
    });
  });
  function timeAgo(date) {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);
    const intervals = {
      year: 31536000,
      month: 2592000,
      week: 604800,
      day: 86400,
      hour: 3600,
      minute: 60,
    };

    for (let key in intervals) {
      const interval = Math.floor(seconds / intervals[key]);
      if (interval >= 1) {
        return `${interval} ${key}${interval > 1 ? "s" : ""}`;
      }
    }
    return "Just now";
  }
  document.querySelectorAll(".timeago").forEach((el) => {
    const timestamp = el.getAttribute("data-time");
    if (timestamp) {
      el.textContent = timeAgo(timestamp);
    }
  });
});
function Marquee(selector, speed) {
  const parentSelector = document.querySelector(selector);
  const clone = parentSelector.innerHTML;
  const firstElement = parentSelector.children[0];
  let i = 0;
  parentSelector.insertAdjacentHTML('beforeend', clone);
  parentSelector.insertAdjacentHTML('beforeend', clone);
  parentSelector.insertAdjacentHTML('beforeend', clone);

  function startMarquee() {
    function step() {
      i += speed;
      if (i > firstElement.clientWidth) {
        i = 0;
      }

      firstElement.style.marginLeft = `-${i}px`;
      requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  startMarquee();
}
window.addEventListener('load', () => Marquee('.marquee', 0.4));
const video = document.getElementById('backgroundVideo');
const playPauseButton = document.getElementById('playPauseButton');
const playPauseIcon = document.getElementById('playPauseIcon');
let isPlaying = !video.paused; 
const pauseIcon = `
 <svg class="pause-icon-svg" xmlns="http://www.w3.org/2000/svg" width="24" height="27" viewBox="0 0 24 27" fill="none">
  <path d="M5.78571 0H1.92857C0.863451 0 0 0.863451 0 1.92857V25.0714C0 26.1365 0.863451 27 1.92857 27H5.78571C6.85083 27 7.71429 26.1365 7.71429 25.0714V1.92857C7.71429 0.863451 6.85083 0 5.78571 0Z" fill="black"/>
  <path d="M21.2143 0H17.3572C16.292 0 15.4286 0.863451 15.4286 1.92857V25.0714C15.4286 26.1365 16.292 27 17.3572 27H21.2143C22.2794 27 23.1429 26.1365 23.1429 25.0714V1.92857C23.1429 0.863451 22.2794 0 21.2143 0Z" fill="black"/>
</svg>`;

const playIcon = `
  <svg viewBox="-0.5 0 7 7" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
  fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" 
  stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>play [#1003]</title> <desc>Created with Sketch.</desc> 
  <defs> </defs> <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="Dribbble-Light-Preview" 
  transform="translate(-347.000000, -3766.000000)" fill="#000000"> <g id="icons" transform="translate(56.000000, 160.000000)"> 
  <path d="M296.494737,3608.57322 L292.500752,3606.14219 C291.83208,3605.73542 291,3606.25002 291,3607.06891 L291,3611.93095 
  C291,3612.7509 291.83208,3613.26444 292.500752,3612.85767 L296.494737,3610.42771 C297.168421,3610.01774 297.168421,3608.98319 
  296.494737,3608.57322" id="play-[#1003]"> </path> </g> </g> </g> </g></svg>`;

// Update initial icon based on video state
playPauseIcon.innerHTML = isPlaying ? pauseIcon : playIcon;

// Toggle play/pause functionality
playPauseButton.addEventListener('click', () => {
  if (isPlaying) {
    video.pause();
    playPauseIcon.innerHTML = playIcon; // Change to play icon
  } else {
    video.play();
    playPauseIcon.innerHTML = pauseIcon; // Change to pause icon
  }
  isPlaying = !isPlaying;
});